import { createRouter, createWebHistory } from "vue-router";
import { useAuth, useOidcStore } from "vue3-oidc";
import { computeRole, UserRole } from "@/composables/useUserRole";
import { useUserStore } from "@/store/user";

import SightChildrens from "./sight/childrens";

const OidcCallback = () => import("@/components/OidcCallback.vue");
const Sight = () => import("@/components/Sight.vue");
const NoAccess = () => import("@/components/NoAccess.vue");

const { autoAuthenticate, setRedirectUri } = useAuth();
const oidcStore = useOidcStore();

const routes = [
  {
    path: "/",
    component: Sight,
    children: SightChildrens,
  },
  {
    path: "/no-access",
    name: "NoAccess",
    component: NoAccess,
  },
  {
    path: "/oidc-callback",
    name: "oidcCallback",
    component: OidcCallback,
    meta: { isPublic: true },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

async function renewSilently() {
  const renewed = await oidcStore.state.value.userManager?.signinSilent();
  oidcStore.actions.value.setUser(renewed);
  return !oidcStore.state.value.hasExpiresAt;
}

const NO_ACCESS_STATUSES = new Set([401, 403]);

async function loadGroups() {
  const userStore = useUserStore();
  try {
    await userStore.loadCurrentUser();
    return userStore.groups;
  } catch (error) {
    return NO_ACCESS_STATUSES.has(error?.response?.status) ? [] : null;
  }
}

router.beforeEach(async (to) => {
  if (to.meta.isPublic) return;

  const { user, hasExpiresAt: isExpired } = oidcStore.state.value;
  const renewed = isExpired && (await renewSilently().catch(() => false));
  if (!renewed && (!user || isExpired)) {
    setRedirectUri(to.fullPath);
    await autoAuthenticate(to.fullPath);
  }

  const groups = await loadGroups();
  if (groups && computeRole(groups) === UserRole.NO_ACCESS && to.name !== "NoAccess") {
    return { name: "NoAccess" };
  }
});

export default router;
